<template>
  <v-menu v-model="event.open" full-width offset-x>
    <template v-slot:activator="{ on }">
      <div v-if="!event.time" v-ripple class="my-event" v-on="on" v-html="event.name"></div>
    </template>
    <v-card color="grey lighten-4" min-width="350px" flat>
      <v-toolbar color="primary" dark>
        <v-toolbar-title v-html="event.name"></v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title primary-title>
        <span v-html="event.description"></span>
      </v-card-title>
      <v-card-actions v-if="!hideEdit">
        <v-spacer></v-spacer>
        <v-btn color="accent" flat @click="event.open = !event.open">Odrzuć</v-btn>
        <v-btn v-if="Auth.check(Permissions['DATES_DELETE'])" color="error" flat @click="$emit('delete', event)">Usuń</v-btn>
        <v-btn v-if="Auth.check(Permissions['DATES_ADDEDIT'])" color="success" flat @click="$emit('edit', event)">Edytuj</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: ["event", "hideEdit"],
  data: () => ({})
};
</script>

<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
</style>